
import { searchBizUserRole, listRole } from "@/api/common.js";
import { getMediationRoomUserInfoList } from "@/api/casespace.js";
export const UserRole = {//获取工作人员角色列表
    data() {
        return {
            meetingTypeList: [],
            // meetingTypeEnum: {},
            meetingTypeEnum: {
                LITIGANT: '当事人',
                MEDIATOR: "仲裁员",
                APPLICANT: "申请人",
                RESPONDENT: "被申请人",
                APPLICANT_AGENT: "申请人代理人",
                RESPONDENT_AGENT: "被申请人代理人",
                CLERK: "书记员",
                JUROR: "陪审员",
                LITIGANT_WITNESS: "证人",
                LITIGANT_THIRD: "第三人",
                ASSISTANT_JUDGE: "法官助理"
            },
        }
    },
    created() {
        this.ApisearchBizUserRole()
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        ApisearchBizUserRole() {
            // searchBizUserRole({}).then(res => {
            //     if (res.data.code === 1000) {
            //         this.meetingTypeList = res.data.data
            //     } else {
            //         this.$message({
            //             type: 'error',
            //             message: res.data.message
            //         })
            //     }
            // }, err => {

            // })
            // listRole({
            //     "pageIndex": 1,
            //     "pageSize": 10000,
            //     "roleType": "",
            // }).then((res) => {
            //     if (res.data.code === 1000) {
            //         let resdata = res.data.data.list;
            //         for(let i = 0; i < resdata.length; i++) {
            //             let item = resdata[i]
            //             // this.meetingTypeEnum[item.roleCode] = item.roleName
            //         }
            //     }
            // }, () => {

            // });
        }
    }
}

export const GetMediationRoomUserInfoList = {//获取当前案件人员
    data() {
        return {
            
        }
    },
    created() {
        this.ApigetMediationRoomUserInfoList()
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        ApigetMediationRoomUserInfoList() {
            getMediationRoomUserInfoList({
                id: this.$route.query.meetingid
            }).then(res => {
                if (res.data.code === 1000) {
                    this.tableDataUserinfoList = res.data.data
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            }, err => {

            })
        },
        meetingUserName(userIdArr) {
            //获取人员类型名字
            userIdArr = userIdArr.split(',')
            let nowUserName=''
            this.tableDataUserinfoList.forEach(item => {
                if(userIdArr.length > 1) {
                    userIdArr.forEach(ele => {
                        if(item.userId == ele) {
                            nowUserName += `@${item.userName}  `
                        }
                    });
                } else {
                    if(item.userId == userIdArr[0]) {
                        nowUserName += item.userName
                    }
                }
            })
            return nowUserName
        }
    }
}